import {SpeechRecognition} from "@capacitor-community/speech-recognition";
import {VoiceRecorder} from "capacitor-voice-recorder";

import {transcribeAudioBase64} from "@/helper/chat/assistantAPI";
import {sleep} from "openai/core";
import {env} from "@/helper/env";
import {Capacitor} from "@capacitor/core";
import {kapitelErrorHandler} from "@/helper/error";

export type TranscribeStatus = 'ready'|'preparing'|'listening'|'transcribing'
export namespace TranscribeStatus {
    export const isResting = (s: TranscribeStatus) => s === 'ready'
}

export const SpeechToTextRecorder = async () : Promise<any | undefined> => {
    // transcription promise
    let res : (result: string|undefined) => void = () => {}
    let rej : () => void = () => {}
    const promise : Promise<string|undefined> = new Promise((resolve, reject) => {
        res = resolve
        rej = reject
    });

    // console.log(await SpeechRecognition.available())
    // console.log(await SpeechRecognition.checkPermissions())

    // try on device speech recognition
    try {
        if(Capacitor.isNativePlatform() && await SpeechRecognition.available()){
            let permissionStatus = await SpeechRecognition.checkPermissions();
            if (permissionStatus.speechRecognition !== "granted") {
                permissionStatus = await SpeechRecognition.requestPermissions();
            }
            if (permissionStatus.speechRecognition !== "denied") {
                return {
                    type: 'SpeechRecognition',
                    start: async () => {
                        SpeechRecognition.start({
                            language: "de-DE",
                            maxResults: 1,
                            // prompt: "Frag' AInes",
                            partialResults: false,
                            popup: false,
                        }).then(result => {
                            const text:string|undefined = result.matches ? result.matches[0] : undefined;

                            res(text)
                        }).catch(error => {
                            rej()
                            const errorMessage = typeof error === 'string' ? error : error?.message
                            switch (errorMessage) {
                                case 'No match':
                                case 'No speech input':
                                    kapitelErrorHandler('Ich konnte dich nicht verstehen, probier es nochmal!')
                                    break
                                default:
                                    kapitelErrorHandler(errorMessage)
                                    break
                            }
                        })

                        return
                    },
                    stop: async () => {SpeechRecognition.stop(); return},
                    transcription: promise
                }
            }
        }
    } catch (e) {
        rej()
        console.log(e)
    }

    // try voice recorder & online transcribe
    try {
        const canRecord = await VoiceRecorder.canDeviceVoiceRecord();
        if (canRecord.value) {
            let permissionToRecord = await VoiceRecorder.hasAudioRecordingPermission();
            if (!permissionToRecord.value) {
                permissionToRecord = await VoiceRecorder.requestAudioRecordingPermission();
            }
            if (permissionToRecord.value) {
                return {
                    type: 'VoiceRecorder',
                    start: async () => {
                        try {
                            await VoiceRecorder.startRecording();
                        } catch (e) {
                            rej()
                            kapitelErrorHandler(e)
                            return
                        }
                    },
                    stop: async () => {
                        try {
                            const recording = await VoiceRecorder.stopRecording();
                            const text = await transcribeAudioBase64(recording.value.recordDataBase64, recording.value.mimeType)
                            res(text)
                        } catch (e) {
                            switch (e){
                                case "no speech detected":
                                    kapitelErrorHandler('Ich konnte dich nicht verstehen, probier es nochmal!')
                                    break
                                default:
                                    kapitelErrorHandler(e)
                                    break
                            }

                            rej()
                        }
                    },
                    transcription: promise
                }
            }
        }
    } catch (e) {
        rej()
        kapitelErrorHandler(e)
    }

    // try on device speech recognition
    if (env.isDevelopment()) {
        console.warn('SpeechRecognition using faker!!!')
        return {
            type: 'Faker',
            start: async () => {
                return
            },
            stop: async () => {
                sleep(1500).then(() => {
                    res('Findest du nicht auch, dass Spracherkennung Hexenwerk ist?')
                })
            },
            transcription: promise
        }
    }

    return false
}
